var map = {
	"./acque-e-suolo/cover.jpg": 12187,
	"./ecoturismo/cover.jpg": 74197,
	"./energia/cover.jpg": 95624,
	"./formazione/cover.jpg": 99733,
	"./territorio/cover.jpg": 89248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70406;